.PublishBtn {
  width: 108px;
  height: 32px;
}

.Transparent {
  background-color: transparent !important;
}

.LoadingPlaceholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 108px;
  height: 30px;
}

.AppearDisabled {
	opacity: 0.4;
}